module.exports = __webpack_public_path__ + "static/media/tania.ae5396e9.jpg";